export class NginxLocationConfiguration {
    type: string;
    value: string;

    constructor(type: string, value: any) {
        this.type = type;
        this.value = typeof value === 'string' ? value.trim() : value;
    }

    getTypeDescription(): string {
        return NginxLocationConfigurationTypeExt.getDescriptionFromString(this.type);
    }

    getDisplayValue(): string {
        if (this.type === NginxLocationConfigurationType[NginxLocationConfigurationType.ENABLE_WEB_SOCKET]){
            return this.value ? "启用" : "禁用";
        }
        if (this.type === NginxLocationConfigurationType[NginxLocationConfigurationType.PROXY_READ_TIMEOUT]){
            return this.value + "秒";
        }
        return this.value;
    }

}

export enum NginxLocationConfigurationType {

    ENABLE_WEB_SOCKET,
    CLIENT_MAX_BODY_SIZE,
    CUSTOM,
    PROXY_READ_TIMEOUT,
    DEFAULT_TYPE,

}

export namespace NginxLocationConfigurationTypeExt {

    export function values(): NginxLocationConfigurationType[] {
        return Object.values(NginxLocationConfigurationType)
            .filter(value => typeof value === 'number') as NginxLocationConfigurationType[];
    }

    export function getDescriptionFromString(type: string): string {
        return getDescription(fromString(type));
    }

    export function fromString(type: string): NginxLocationConfigurationType {
        return NginxLocationConfigurationType[type as keyof typeof NginxLocationConfigurationType] as NginxLocationConfigurationType;
    }

    export function getDescription(type: NginxLocationConfigurationType): string {
        switch (type) {
            case NginxLocationConfigurationType.CUSTOM:
                return "自定义配置";
            case NginxLocationConfigurationType.ENABLE_WEB_SOCKET:
                return "启用WebSocket";
            case NginxLocationConfigurationType.CLIENT_MAX_BODY_SIZE:
                return "请求大小限制";
            case NginxLocationConfigurationType.PROXY_READ_TIMEOUT:
                return "读取超时";
            case NginxLocationConfigurationType.DEFAULT_TYPE:
                return "返回类型";
        }
    }

}